import { cacheDom } from "../utils/QuerySelectors.js"
import { setOpen, setAddress } from '../apps/store/addressSlice'
import store from '../apps/store/store'
import { validateEmail } from "../utils/helpers.js"

const dom = {}

const qs = {
  email: 'type="email"',
  password: 'type="password"',
  confirmPassword: 'data-confirm-password',
  submit: 'data-submit',
  loginForm: 'action="/account/login"',
  recoverForm: 'action="/account/recover"',
  registerForm: 'action="/account"',
  resetForm: 'action="/account/reset"',
  activateForm: 'action="/account/activate"',
  addressAdd: 'data-address-add', 
  newAddressData: 'data-new-address-data',
  mobileNavSelected: 'data-mobile-nav-selected',
  wishlist: 'data-account-wishlist',
  wishlistCount: 'data-account-wishlist-count',
  wishlistActions: 'data-account-wishlist-actions',
  removeAllFromWishlist: 'data-account-wishlist-remove-all',
  shareWishlist: 'data-account-wishlist-share',
  shareHtml: 'data-wishlist-share',
  shareSuccessHtml: 'data-wishlist-share-success',
  shareSendBtn: 'data-wishlist-share-send',
  shareSenderName: 'data-wishlist-share-name',
  shareToEmail: 'data-wishlist-share-email',
  shareMessage: 'data-wishlist-share-message',
  continueShopping: 'data-account-continue-shopping',
}
const qsAll = {
  accountNavs: 'data-account-item',
  accountMobileNavs: 'data-mobile-account-item',
  accountUrls: 'data-account-url',
  editAddressBtns: 'data-address-edit',
  removeAddressBtns: 'data-confirm-message',
  removeFromWishlist: 'data-wishlist-remove',
}

const addError = (form, parent, text) => {
  parent.classList.add('input-wrap--second')
  const node = document.createElement("p")
  const textnode = document.createTextNode(text)
  node.appendChild(textnode)
  node.className = 'input-error'
  parent.appendChild(node)
  const submitBtn = form.querySelector(`[${qs.submit}]`)
  if(submitBtn) {
    submitBtn.classList.remove('button--primary__filled')
    submitBtn.classList.add('button--error')
    submitBtn.innerHTML = 'Please Try Again'
  }
}
const backSubmitButton = (form) => {
  const submitBtn = form.querySelector(`[${qs.submit}]`)
  if(submitBtn) {
    submitBtn.classList.add('button--primary__filled')
    submitBtn.classList.remove('button--error')
    submitBtn.innerHTML = submitBtn.dataset.submit
  }
}

const setupForm = (form) => {
  const emailField = form.querySelector(`[${qs.email}]`)
  const emailWrap = emailField ? emailField.closest('.input-wrap') : null
  const passwordField = form.querySelector(`[${qs.password}]`)
  const passwordWrap = passwordField ? passwordField.closest('.input-wrap') : null

  form.querySelector(`[${qs.submit}]`).addEventListener('click', (e) => {
    if(emailWrap) {
      const emailValue = form.querySelector(`[${qs.email}]`).value.trim()
      let text = null
      if(emailValue == '') {
        text = "Can't be blank"
      } else if(!validateEmail(emailValue)) {
        text = "Invalid"
      }
      if(text) {
        e.preventDefault()
        if(emailWrap.querySelector('.input-error')) emailWrap.querySelector('.input-error').remove()
        addError(form, emailWrap, text)
        
        emailWrap.querySelector(`[${qs.email}]`).addEventListener('keypress', () => {
          if(emailWrap.querySelector('.input-error')) emailWrap.querySelector('.input-error').remove()
          emailWrap.classList.remove('input-wrap--second')
          backSubmitButton(form)
        })
      }
    }
    if(passwordWrap) {
      if(passwordField.value == '') {
        e.preventDefault()
        if(passwordWrap.querySelector('.input-error')) passwordWrap.querySelector('.input-error').remove()
        addError(form, passwordWrap, "Can't be blank")
        
        passwordWrap.querySelector(`[${qs.password}]`).addEventListener('keypress', () => {
          if(passwordWrap.querySelector('.input-error')) passwordWrap.querySelector('.input-error').remove()
          passwordWrap.classList.remove('input-wrap--second')
          backSubmitButton(form)
        })
      }

      const confirmPassField = form.querySelector(`[${qs.confirmPassword}]`)
      const confirmPassWrap = confirmPassField ? confirmPassField.closest('.input-wrap') : null
      if(confirmPassField && passwordField.value != confirmPassField.value) {
        e.preventDefault()
        if(confirmPassWrap.querySelector('.input-error')) confirmPassWrap.querySelector('.input-error').remove()
        
        addError(form, confirmPassWrap, "Passwords don’t match")
        
        confirmPassWrap.querySelector(`[${qs.confirmPassword}]`).addEventListener('keypress', () => {
          if(confirmPassWrap.querySelector('.input-error')) confirmPassWrap.querySelector('.input-error').remove()
          confirmPassWrap.classList.remove('input-wrap--second')
          backSubmitButton(form)
        })
      }
    }
  })
}

const updateActionsVisibility = (swatProducts) => {
  if(swatProducts.length > 0) {
    dom.wishlistActions.classList.remove('!hidden')
    dom.wishlistActions.classList.add('flex')
    dom.continueShopping.classList.remove('block')
    dom.continueShopping.classList.add('hidden')
  } else {
    dom.wishlistActions.classList.add('!hidden')
    dom.wishlistActions.classList.remove('flex')
    dom.continueShopping.classList.add('block')
    dom.continueShopping.classList.remove('hidden')
  }
}

const onSuccess = (removedProduct) => {
  console.log(`Successfully removed many Products from the List`, removedProduct)
  _swat.fetch((products) => {
    updateActionsVisibility(products)
    dom.wishlistCount.innerHTML = `${products.length} Item${products.length > 1 ? 's' : ''}`
  })
}

const onError = (error) => {
  console.log("Error while removing many Products from the List", error)
}

const initWishlistSend = () => {
  const shareSendBtn = document.querySelector(`[data-popup] [${qs.shareSendBtn}]`)
  const shareSenderName = document.querySelector(`[data-popup] [${qs.shareSenderName}]`)
  const shareToEmail = document.querySelector(`[data-popup] [${qs.shareToEmail}]`)
  const shareMessage = document.querySelector(`[data-popup] [${qs.shareMessage}]`)
  
  shareSendBtn.addEventListener('click', () => {
    _swat.sendListViaEmail(
      {
        toEmailId: shareToEmail.value,
        fromName: shareSenderName.value,
        note: shareMessage.value,
        lid: null,
      },
      function (r) {
        const clickEvent = new Event('click')
        const close = document.querySelector('[data-popup-close]')
        close.dispatchEvent(clickEvent)
        setTimeout(() => {
          window.openPopup(dom.shareSuccessHtml.innerHTML)
        }, 500)
      },
      function (r) {
        console.log('Error', r)
      }
    )
  })
}

export const setupAccount = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.loginForm) setupForm(dom.loginForm)
  if(dom.recoverForm) setupForm(dom.recoverForm)
  if(dom.registerForm) setupForm(dom.registerForm)
  if(dom.resetForm) setupForm(dom.resetForm)
  if(dom.activateForm) setupForm(dom.activateForm)
  dom.accountNavs.forEach((accountNav) => {
    accountNav.addEventListener('click', (e) => {
      e.stopPropagation()
      dom.accountNavs.forEach((navItem) => {
        if(navItem == accountNav) {
          navItem.closest('li').classList.add('account-nav--item__active')
          dom.mobileNavSelected.innerHTML = accountNav.innerHTML
        } else {
          navItem.closest('li').classList.remove('account-nav--item__active')
        }
      })
    })
  })
  dom.accountMobileNavs.forEach(accountMobileNav => {
    accountMobileNav.addEventListener('click', (e) => {
      e.stopPropagation()
      dom.mobileNavSelected.innerHTML = accountMobileNav.innerHTML
      dom.mobileNavSelected.classList.remove('mobile-nav-selected--focus')
      const url = accountMobileNav.closest('li').dataset.accountUrl
      dom.accountNavs.forEach(navItem => {
        const newUrl = navItem.closest('li').dataset.accountUrl
        navItem.closest('li').classList.toggle('account-nav--item__active', url == newUrl)
      })
    })
  })
  
  dom.accountUrls.forEach((accountUrl) => {
    const navUrl = accountUrl.dataset.accountUrl
    const pathName = location.href.split('?')[0].replace(location.origin, '') 
    if(typeof navUrl != 'undefined' && navUrl) {
      if(navUrl == pathName) {
        accountUrl.classList.add('account-nav--item__active')
        dom.mobileNavSelected.innerHTML = accountUrl.dataset.accountTitle
      } else {
        accountUrl.classList.remove('account-nav--item__active')
      }
    }
  })
  if(dom.mobileNavSelected) {
    dom.mobileNavSelected.addEventListener('click', (e) => {
      e.stopPropagation()
      dom.mobileNavSelected.classList.toggle('mobile-nav-selected--focus')
    })
    window.addEventListener('click', () => {
      dom.mobileNavSelected.classList.remove('mobile-nav-selected--focus')
    })
  }
  if(dom.addressAdd) {
    dom.addressAdd.addEventListener('click', (e) => {
      const newAddressData = JSON.parse(dom.newAddressData.innerHTML)
      newAddressData.country = 'United States'
      store.dispatch(setAddress(newAddressData))
      store.dispatch(setOpen(true))
    })
  }
  dom.editAddressBtns.forEach(editAddress => {
    editAddress.addEventListener('click', (e) => {
      store.dispatch(setAddress(JSON.parse(e.target.closest('[data-address]').querySelector('[data-edit-address-data]').innerHTML)))
      store.dispatch(setOpen(true))
    })
  })
  dom.removeAddressBtns.forEach(removeAddressBtn => {
    removeAddressBtn.addEventListener('click', (e) => {
      e.preventDefault()
      if (confirm(removeAddressBtn.dataset.confirmMessage)) {
        fetch(removeAddressBtn.dataset.target, {
          method: 'DELETE',
        })
        .then(response => response.text())
        .then(response => {
          location.reload()
        })
        .catch((error) => {
          console.error('Error:', error)
        })
      }
    })
  })
  if(dom.wishlist) {
    setTimeout(() => {
      _swat.fetch((products) => {
        console.log(products)
        updateActionsVisibility(products)
        dom.wishlistCount.innerHTML = `${products.length} Item${products.length > 1 ? 's' : ''}`
        products.forEach(product => {
          fetch(`${product.du}?view=data`)
          .then(response => {
            return response.json()
          })
          .then(result => {
            console.log(result)
            dom.wishlist.innerHTML +=  `
              <div class="h-full"
                id="wishlist-item-${result.id}-${product.epi}" 
                product-tile 
                json='${JSON.stringify(result).replace("'", "’")}'
                lazyload='true'
                columns_desktop='4'
                columns_tablet='3'
                columns_mobile='2'
                flatlay='true'
                selected_variant_id='${product.epi}'
              ></div>`
            window.setupProductTiles(dom.wishlist.querySelectorAll('[product-tile]:empty'))
            setTimeout(() => {
              const removeBtn = document.querySelector(`#wishlist-item-${result.id}-${product.epi} [${qsAll.removeFromWishlist}]`)
              if(removeBtn) {
                removeBtn.addEventListener('click', (e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  const variantId = product.epi
                  const swymProducts = products.filter(product => product.epi == parseInt(variantId))
                  if(swymProducts.length > 0) {
                    _swat.removeFromWishList(swymProducts[0], onSuccess, onError)
                    removeBtn.closest('[product-tile]').remove()
                  }
                })
              }
            }, 500)
          })
        })
      })
    }, 1000)
    dom.removeAllFromWishlist.addEventListener('click', () => {
      _swat.fetch((products) => {
        products.forEach((product, index) => {
          if(index == products.length - 1)
            _swat.removeFromWishList(product, onSuccess, onError)
          else
            _swat.removeFromWishList(product)
        })
        dom.wishlist.innerHTML = ''
      })
    })
    dom.shareWishlist.addEventListener('click', () => {
      window.openPopup(dom.shareHtml.innerHTML)
      initWishlistSend()
    })
  }
}